module.exports = __webpack_public_path__ + "static/ConcishareWeb-29cc79b5936046f736b13e677972c4b4.png";